(function () {
  'use strict';

  if (window.__qteedyJoyfyBridgeInstalled) {
    return;
  }

  window.__qteedyJoyfyBridgeInstalled = true;

  function getStatusElement() {
    return document.getElementById('easyquote-status');
  }

  function setStatus(message) {
    var status = getStatusElement();

    if (status) {
      status.textContent = message;
    }
  }

  function getEmailInput() {
    return document.getElementById('cartEmail');
  }

  function waitForQteedy(timeout) {
    timeout = timeout || 5000;

    return new Promise(function (resolve, reject) {
      var start = Date.now();

      function check() {
        if (
          window.QTEEDY &&
          typeof window.QTEEDY.execute === 'function'
        ) {
          resolve(window.QTEEDY);
          return;
        }

        if (Date.now() - start >= timeout) {
          reject(
            new Error(
              'Qteedy storefront script did not become available.'
            )
          );
          return;
        }

        setTimeout(check, 100);
      }

      check();
    });
  }

  async function createQuote(event) {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();
    }

    var emailInput = getEmailInput();

    if (!emailInput) {
      console.error(
        '[Qteedy Joyfy] #cartEmail could not be found.'
      );
      return;
    }

    var email = emailInput.value.trim();

    if (!email) {
      setStatus('Please enter your email address.');
      emailInput.focus();
      return;
    }

    setStatus('Creating your quote...');

    try {
      var qteedy = await waitForQteedy(5000);

      console.log(
        '[Qteedy Joyfy] Executing create-quote'
      );

      var result = qteedy.execute('create-quote');

      if (
        result &&
        typeof result.then === 'function'
      ) {
        await result;
      }
    } catch (error) {
      console.error(
        '[Qteedy Joyfy] Quote error:',
        error
      );

      setStatus(
        'Unable to create the quote. Please try again.'
      );
    }
  }

  /*
   * Joyfy dynamically replaces cart drawer HTML.
   * Therefore we deliberately use delegated listeners
   * rather than binding directly to #create-quote.
   */
  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;

      if (!target) {
        return;
      }

      var button = target.closest
        ? target.closest('#create-quote')
        : null;

      if (!button) {
        return;
      }

      createQuote(event);
    },
    true
  );

  /*
   * Allow Enter while focused on the email field.
   */
  document.addEventListener(
    'keydown',
    function (event) {
      if (
        event.key === 'Enter' &&
        event.target &&
        event.target.id === 'cartEmail'
      ) {
        createQuote(event);
      }
    },
    true
  );

  console.log(
    '[Qteedy Joyfy] Bridge loaded.'
  );
})();